<script>
  import BadgeState from "../../Stores/badgeState"
  import fileTemplateState from "../../../File/stores/fileTemplateJsonData"
  import { copyToClipboard } from "../../../../Publish/SinglePublish/script"
  import notify from "../../../../../Script/notify"
  import { afterUpdate, createEventDispatcher } from "svelte"
  import { loadTooltip } from "../../../../../Script/loadTooltip"
  const dispatch = createEventDispatcher()

  export let template

  /**
   * @type {copiedInfo}
   */
  let copiedInfo = {
    close() {},
  }

  const goInitialState = () => {
    $BadgeState = {
      name: "",
      baseInfo: {},
      operations: [],
      fonts: [],
      apiFonts: [],
      download: false,
      cursorPosition: {
        x: 0,
        y: 0,
      },
      canvasColor: "transparent",
      activeFontStyles: [],
      activeTextAlign: "center",
      activeTextColor: "#f2072e",
      goBack: false,
      resumeModal: false,
      footer: "GENERAL",
    }
    // ($fileTemplateState)
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

<!-- normal  list -->
<div class="group">
  <div class="flex w-full justify-between rounded-md border-2 border-transparent bg-white p-3 text-white hover:shadow-md dark:bg-lightgray dark:hover:border-blue-500">
    <div class="flex w-full flex-col truncate">
      <h2 title={template.name} class="select-none truncate break-words text-sm font-bold text-gray-d00 dark:text-white/70 md:text-lg">
        {template.name}
      </h2>
      <h2 class="select-none truncate text-xs font-medium text-gray-500 md:text-sm">
        <!-- {new Date(template.created).toString().slice(0, 24)} -->
        {new Date(template.modified || template.created).toString().slice(0, 24)}
      </h2>
    </div>
    <div class="flex w-full items-center justify-end px-3 text-gray-100 2xl:w-auto">
      <button
        name="tooltip"
        id="Copy ID"
        tooltip-position="top"
        on:click={() => {
          copiedInfo.close()
          copyToClipboard(template.id)
          copiedInfo = notify.info("Template ID Copied to clipboard")
        }}
        class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white focus:outline-none active:text-white peer-hover:text-white sm:px-5"
      >
        <i class="fa-solid fa-copy" />
        <span class="hidden lg:block">&nbsp;&nbsp;Copy&nbsp;ID</span>
      </button>
      <a name="tooltip" id="Edit" tooltip-position="top" on:click={goInitialState} href="#/templates/badge/edit?id={template.id}" class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-yellow-500 hover:bg-yellow-500 hover:text-white focus:outline-none active:text-white peer-hover:text-white sm:px-5">
        <i class="fa-solid fa-pen-field" />
        <span class="hidden lg:block">&nbsp;&nbsp;Edit</span>
      </a>
      <button name="tooltip" id="Duplicate" tooltip-position="top" on:click={() => dispatch("onDuplicate")} class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-emerald-500 hover:bg-emerald-500 hover:text-white focus:outline-none active:bg-emerald-400 active:text-white md:px-5 xl:w-32">
        <i class="fa-solid fa-clone" />
        <span class="hidden lg:block">&nbsp;&nbsp;Duplicate</span>
      </button>
      <button name="tooltip" id="Delete" tooltip-position="top" on:click class="flex cursor-pointer select-none items-center justify-center rounded-full px-3 py-2 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white focus:outline-none active:text-white sm:px-5">
        <i class="fa-solid fa-trash-can" />
        <span class="hidden lg:block">&nbsp;&nbsp;Delete</span>
      </button>
    </div>
  </div>
</div>
